<template>
    <div class="w-full">
        <div class="button-container disabled-button">
            <a :class="`disabled-${buttonsType}`" class="btn btn-green btn-outline">
                <img src="/images/icons/cancel.svg" height="32" width="32" alt="">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "DisabledButton",
    props: {
        buttonsType: {
            type: String,
            required: true
        }
    }
}
</script>
